
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useBlockNavigation = () => {
  const location = useLocation();

  useEffect(() => {
    const handlePopState = (event: PopStateEvent) => {
      // Bloquear navegación hacia atrás solo si realmente es navegación
      if (event.state === null) {
        event.preventDefault();
        window.history.pushState(null, '', window.location.href);
      }
    };

    const handleKeyDown = (event: KeyboardEvent) => {
      // Solo bloquear si no estamos en un campo de entrada
      const activeElement = document.activeElement;
      const isInInputField = activeElement && 
        (['INPUT', 'TEXTAREA', 'SELECT'].includes(activeElement.tagName) || 
         (activeElement as HTMLElement).isContentEditable);

      if (isInInputField) return;

      // Bloquear tecla de borrar/backspace para navegación
      if (event.key === 'Backspace') {
        event.preventDefault();
      }
      
      // Bloquear Alt + flecha izquierda/derecha (navegación del navegador)
      if (event.altKey && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) {
        event.preventDefault();
      }
    };

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      // Solo mostrar confirmación si hay cambios no guardados o navegación externa
      const isExternalNavigation = !event.target || 
        !(event.target as Window).location.pathname.startsWith('/admin');
      
      if (isExternalNavigation) {
        event.preventDefault();
        event.returnValue = '';
      }
    };

    // Función más selectiva para bloquear gestos del trackpad
    const handleWheel = (event: WheelEvent) => {
      // Solo bloquear si es un gesto muy específico de navegación del navegador
      const isHorizontalSwipe = Math.abs(event.deltaX) > Math.abs(event.deltaY) && 
        Math.abs(event.deltaX) > 100; // Umbral más alto
      
      // Solo bloquear en los bordes de la pantalla y si no hay modificadores
      const isNearEdge = event.clientX < 50 || event.clientX > window.innerWidth - 50;
      
      if (isHorizontalSwipe && isNearEdge && !event.ctrlKey && !event.metaKey && !event.shiftKey) {
        console.log('🚫 Blocking potential browser navigation gesture');
        event.preventDefault();
        event.stopPropagation();
      }
    };

    // Agregar entrada al historial para bloquear navegación hacia atrás
    window.history.pushState(null, '', window.location.href);

    // Agregar event listeners con configuración menos agresiva
    window.addEventListener('popstate', handlePopState);
    document.addEventListener('keydown', handleKeyDown);
    window.addEventListener('beforeunload', handleBeforeUnload);
    
    // Solo agregar wheel listener en los bordes para ser menos intrusivo
    document.addEventListener('wheel', handleWheel, { passive: false });

    // Cleanup
    return () => {
      window.removeEventListener('popstate', handlePopState);
      document.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('beforeunload', handleBeforeUnload);
      document.removeEventListener('wheel', handleWheel);
    };
  }, [location]);
};
